import React from "react";
import { init, reducer } from "./state";
import { Link, useHistory } from "react-router-dom";
import home_background from "@assets/home_background.jpg";
import { AttestationModal } from "./modal/attestationModal";
import { Box, Button, Grid, Typography, makeStyles } from "@material-ui/core";

const useClassnames = makeStyles({
  root: {
    backgroundImage: `url(${home_background})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "505px 386px",
    backgroundPosition: "center right",
  },
});

export const Home: React.FC = () => {
  const history = useHistory();
  const classnames = useClassnames();
  const [state, dispatch] = React.useReducer(reducer, {}, init);

  const closeModal = () => {
    dispatch({
      type: "ATTESTATION_MODAL:CLOSE",
    });
  };

  // Handlers

  function handleSubmitNewRequestButtonClick(
    event: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ): void {
    if (event.shiftKey) {
      event.preventDefault();
      history.push("/requests");
    }
  }

  function handleAcceptAttestationButtonClick() {
    dispatch({
      type: "ATTESTATION_MODAL:OPEN",
    });
  }

  return (
    <React.Fragment>
      <Grid container spacing={2} className={classnames.root}>
        <Grid
          item
          xs={7}
          component={Box}
          display="flex"
          flexDirection="column"
          justifyContent="center"
        >
          <Box>
            <Typography variant="h4" component="h1">
              <Box
                component="span"
                display="block"
                fontWeight="fontWeightMedium"
              >
                WELCOME TO
              </Box>
              <Box
                component="strong"
                display="block"
                fontSize="h1.fontSize"
                fontWeight="fontWeightBold"
                color="primary.dark"
              >
                GEARS
              </Box>
            </Typography>
            <Typography>
              Global Employee Access Request System is an application that
              provides a quick, easy and efficient way to manage system access
              requests.
            </Typography>
          </Box>
          <Box display="flex" py={6}>
            <Box>
              <Button
                to="/request"
                component={Link}
                onClick={handleSubmitNewRequestButtonClick}
              >
                Submit New Request
              </Button>
            </Box>
            <Box pl={2}>
              <Button to="/dashboard/approve-request" component={Link}>
                Approve Request
              </Button>
            </Box>
            <Box pl={2}>
              <Button
                to="/"
                component={Link}
                onClick={handleAcceptAttestationButtonClick}
              >
                Accept Attestation
              </Button>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <AttestationModal
        isOpen={state.attestation_modal.open}
        closeModal={closeModal}
      ></AttestationModal>
    </React.Fragment>
  );
};
